module.exports = {
      id: "default-card-image-usage",
      viewBox: "0 0 1024 683",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#default-card-image",
      toString: function () {
        return this.url;
      }
    }